<template>
	<vs-table :search='true' @search='resetList' ref='table' max-items="10" pagination :data="users_">
		
		<template slot="thead">
			<vs-th>
				<vs-checkbox v-model="all.selected" @change.stop="checkAll('selected')" style="display: inline-flex;margin-left:20px;" />
			</vs-th>
			<vs-th sort-key="first_name">{{$t('FirstName')}}</vs-th>
			<vs-th sort-key="last_name">{{$t('LastName')}} </vs-th>
			<vs-th sort-key="email">Email</vs-th>
			<vs-th sort-key="id_number">{{$t('IdNumber')}}</vs-th>
			<vs-th sort-key="mobile_number">{{$t('MobileNumber')}}</vs-th>
			<vs-th>{{$t('Weight')}}</vs-th>
			<vs-th>
				{{$t('IsSpeaker')}}
				<vs-checkbox :disabled='!all.selected' v-model="all.speaker" @change.stop="checkAll('speaker')" style="display: inline-flex;margin-left:20px;" />
			</vs-th>
			<vs-th>
				{{$t('IsModerator')}}
				<vs-checkbox :disabled='!all.selected' v-model="all.moderator" @change.stop="checkAll('moderator')" style="display: inline-flex;margin-left:20px;" />
			</vs-th>
		</template>

		<template slot-scope="{data}">
			<vs-tr :key="indextr" v-for="(tr, indextr) in data">
				<vs-td>
					<vs-checkbox @change.stop="checkAll('selected', $event.target.value, tr.id)" v-model="tr.selected" style="display: inline-flex;margin-left:20px;" />
				</vs-td>
				<vs-td>{{ tr.first_name }}</vs-td>
				<vs-td>{{ tr.last_name }}</vs-td>
				<vs-td>{{ tr.email }}</vs-td>
				<vs-td>{{ tr.id_number }}</vs-td>
				<vs-td>{{ tr.mobile_number }}</vs-td>
				<vs-td>
					<vs-input
						:disabled='!tr.selected'
						v-model="tr.weight"
						class="w-full"
					/>
				</vs-td>
				<vs-td>
					<vs-checkbox :disabled='!tr.selected' @change.stop="checkAll('speaker', $event.target.value, tr.id)" v-model="tr.is_speaker" style="display: inline-flex;margin-left:20px;" />
				</vs-td>
				<vs-td>
					<vs-checkbox :disabled='!tr.selected' @change.stop="checkAll('moderator', $event.target.value, tr.id)" v-model="tr.is_moderator" style="display: inline-flex;margin-left:20px;" />
				</vs-td>
			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
export default {
    name: 'AddAttendantUsers',
    props: ['event', 'attendees'],
    data: () => ({
		q: '',
		users: [],
		all: {
			speaker: false,
			moderator: false,
			selected: false,
		}
    }),
    computed: {
		existing_ids() { return this.attendees.map(p => p.id) },
		users_(){ return this.users.filter(u => this.existing_ids.indexOf(u.id)<0) }
    },
    created() {
      this.getUserLists();
    },
		mounted() {
			const me = this;
			this.$watch('$refs.table.$data.searchx', function(n,o) {
				me.resetList()
			});
		},
    methods: {
			resetList() { 
				this.users = this.users.map(u => ({ 
					...u, 
					is_speaker: false,
					selected: false,
					is_moderator: false,
					weight: null
				}));
			 	this.all = {
					 ...this.all,
					selected: false,
					speaker: false,
					moderator: false
				}

				this.update();
			},
			checkAll(which, onceValue = null, user_id = null) { 
				if(onceValue == null) {
					if(which == 'speaker')
						this.users = this.users.map(u => ({...u, is_speaker: this.all.speaker}))
					else if(which == 'moderator')
						this.users = this.users.map(u => ({...u, is_moderator: this.all.moderator}))
					else if(which == 'selected')
						this.users = this.users.map(u => ({...u, selected: this.all.selected}))
				}else {
					if(which == 'selected') {
						this.all.selected = this.all.speaker = this.all.moderator = false;
						const user = onceValue=='true' ? this.users.find(u => u.id==user_id) : null;
						if(user) {
							user.weight = null; user.is_moderator = user.is_speaker = false; 
						}
					}
					if(which == 'speaker' && this.all.speaker) this.all.speaker = false;
					if(which == 'moderator' && this.all.moderator) this.all.moderator = false;
				}

				this.update();
			},
			update() {
				this.$nextTick(() => {
					const invitees = this.users_.filter(u => u.selected);
					this.$emit('update', invitees);
				})
			},
			async getUserLists() {
					this.$vs.loading();
					try{
							const response = await this.$store.dispatch("getUserLists");
							this.$vs.loading.close();
							this.users = response.data.data.map(u => {
								return {
									...u,
									selected: false,
									weight: null,
									is_speaker: false,
									is_moderator: false,
								}
							});

							this.update();
					}catch(error){
							this.$log.error('File : add-attendant-users.vue | Function : getUserLists() | Error :', error);
							this.$vs.loading.close();
							console.error(error);
							// Error response
							this.$vs.notify({
									title: $t("FailedToLoadData"),
									text: error,
									color: "danger",
									position: "top-center"
							});
					}
			},
    }
}
</script>

<style>

</style>